<template>
  <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="200px" height="200.00px" viewBox="0 0 1024 1024" version="1.1">
    <path
      d="M901.632 926.72c0 12.8-5.12 25.088-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.304V48.64c0-12.8 5.12-25.6 14.336-34.304C144.896 5.12 157.696 0 170.496 0h418.816c12.8 0 25.6 5.12 34.816 14.336l263.68 263.68c9.216 9.216 14.336 21.504 14.336 34.816V926.72z"
      fill="#EBECF0" />
    <path
      d="M901.632 926.72v48.64c0 12.8-5.12 25.6-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-27.136 0-48.64-22.016-48.64-48.64V926.72c0 12.8 5.12 25.088 14.336 34.304 9.216 9.216 21.504 14.336 34.304 14.336h682.496c27.136 0 48.64-22.016 48.64-48.64z"
      fill="#C1C7D0" />
    <path
      d="M24.064 536.576h975.36v243.712c0 27.136-22.016 48.64-48.64 48.64H73.216c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.816v-243.2z"
      fill="#0092D3" />
    <path d="M121.856 536.576V438.784L24.064 536.576h97.792z m779.776 0l1.024-97.792 97.28 97.792h-98.304z" fill="#007199" />
    <path
      d="M901.632 312.832v6.656h-263.68c-27.136 0-48.64-22.016-48.64-48.64V0c12.8 0 25.6 5.12 34.816 14.336l264.192 263.68c8.704 9.216 13.824 21.504 13.312 34.816z"
      fill="#C1C7D0" />
    <path
      d="M278.016 769.536h-56.32v-188.928H296.96l33.792 118.272 32.768-118.272h75.264v188.928H382.976V711.68l1.024-29.696 3.072-33.792h-1.024l-33.792 121.344h-43.008l-34.816-121.344 2.048 27.648 2.048 29.696v64zM530.944 769.536h-61.44v-188.928h90.624c52.736 0.512 79.872 22.016 81.408 63.488-0.512 44.032-27.136 66.048-79.36 66.56h-30.72v58.88z m0-102.912h25.6c16.384 0 24.576-7.68 24.576-22.528 0-12.8-10.752-19.456-32.768-19.456h-17.408v41.984zM649.216 730.112v-43.008l87.552-102.912h50.176v105.984h23.552v39.936h-23.552v38.912h-51.2v-38.912h-86.528z m86.528-96.256l-44.032 56.32h44.032v-56.32z"
      fill="#FFFFFF" />
  </svg>
</template>

<script>
export default {
  name: 'MpIcon',
}
</script>

<style></style>
